import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getMovieDetails } from "../features/movieSlice";

const MovieCard = ({
  image,
  title,
  overview,
  vote_average,
  release_date,
  vote_count,
  poster_path,
  popularity,
  media_type,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const getMovieData = () => {
    dispatch(
      getMovieDetails({
        image,
        title,
        overview,
        vote_average,
        release_date,
        vote_count,
        poster_path,
        popularity,
        media_type,
      })
    );

    history.push("/details");
  };

  return (
    <div
      className="transition duration-200 ease-in transform sm:hover:scale-105 cursor-pointer"
      onClick={getMovieData}
    >
      <div className="">
        <div className="px-3 py-2 border border-gray-800 shadow-2xl">
          <img src={`${image}`} alt="" className="object-contain" />
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
